import React, {memo} from 'react';
import propTypes from 'prop-types';
import Toast, {ToastContainer} from 'components/ui/Toast';
import {connect} from 'react-redux';
import {applyState, applyDispatch} from 'utils/redux';
import {notifications} from 'modules/notifications/selectors';
import {remove} from 'modules/notifications/actions';

const Notifications = memo(({notifications, remove}) => {
	return (
		<ToastContainer portalTarget="popper">
			{notifications.map(({id, type, message}) => (
				<Toast key={id} type={type} message={message} onClose={() => remove(id)} />
			))}
		</ToastContainer>
	);
});

Notifications.displayName = 'Notifications';

Notifications.propTypes = {
	notifications: propTypes.array,
	remove: propTypes.func,
};

export default connect(
	applyState({notifications}),
	applyDispatch({remove}),
)(Notifications);
